import { Button } from '@material-ui/core'
import * as Assert from 'assert'
import * as React from 'react'
import { useEffect, useState } from 'react'

import Team0Icon from '../../assets/Symbol-1.png'
import Team1Icon from '../../assets/Symbol-2.png'
import Team2Icon from '../../assets/Symbol-3.png'
import Team3Icon from '../../assets/Symbol-4.png'
import Team4Icon from '../../assets/Symbol-5.png'
import { answerInputStyles } from '../../styles/InputStyles'
import { StartedGameDto } from '../../utils/types'
import { GamePuzzleTemplate } from './GamePuzzleTemplate'

const icons = [Team1Icon, Team3Icon, Team4Icon, Team2Icon, Team0Icon]

interface Props {

    secondsLeft: number
    puzzleIndex: number
    game: StartedGameDto
    onComplete(): void
    onReset(): void
}

export const GameGridPuzzleView: React.FC<Props> = ({
    puzzleIndex, game, onComplete, onReset, secondsLeft
}) => {
    const gamePuzzle = game.puzzles[puzzleIndex]
    const puzzle = game.escapeRoom.puzzles[puzzleIndex]

    Assert.ok(puzzle)
    Assert.ok(puzzle.grid)
    Assert.ok(gamePuzzle)
    Assert.ok(gamePuzzle.puzzleId === puzzle.puzzleId)
    const styles = answerInputStyles()

    const [currentTaskIndex, setCurrentTaskIndex] = useState<number>(0)
    const [answers, setAnswers] = useState<string[]>(() => puzzle.tasks.map(() => ''))
    const [answerStatuses, setAnswerStatuses] = useState<(boolean | undefined)[]>(
        () => puzzle.tasks.map(() => undefined))
    const [resetting, setResetting] = useState(false)

    const cleanup = () => {
        setAnswers(puzzle.tasks.map(() => ''))
        setAnswerStatuses(puzzle.tasks.map(() => undefined))
    }

    useEffect(() => {
        cleanup()
    }, [puzzle])

    const allFinished = currentTaskIndex >= answers.length
    const setAnswer = (v: string) => {
        if (allFinished) {
            return
        }

        const newAnswers = [...answers]
        newAnswers[currentTaskIndex] = v.toString()

        setCurrentTaskIndex(currentTaskIndex + 1)
        setAnswers(newAnswers)

    }

    const updateValidated = (result: (boolean | undefined)[]) => {
        Assert.ok(result)
        Assert.ok(result.length === answers.length)

        setCurrentTaskIndex(0)
        setAnswerStatuses(result)

        const allCorrect = result.every((a) => a)
        if (!allCorrect) {
            setResetting(true)
            setTimeout(() => {
                setResetting(false)
                cleanup()
            }, 2000)
        }
    }

    const columns = 1 + puzzle.grid.map((i) => i.column).reduce((p, c) => Math.max(p, c), 0)
    const rows = 1 + puzzle.grid.map((i) => i.row).reduce((p, c) => Math.max(p, c), 0)

    return (
        <GamePuzzleTemplate
            puzzleIndex={puzzleIndex}
            game={game}
            onReset={onReset}
            onComplete={onComplete}
            onValidate={updateValidated}
            canValidate={!resetting}
            answers={answers}
            secondsLeft={secondsLeft}>
            <div className={styles.imageContainer}>
                {icons.map((i) => {
                    return (
                        <img
                            alt="Group icon"
                            src={i}
                            style={{ width: 90, height: 90, padding: '0px 20px' }}/>
                    )
                })}

            </div>
            <table style={{
                width: '70%',
                display: 'flex',
                justifyContent: 'space-between',
                margin: '15px 0',
                padding: '0 50px'
            }}>
                <tbody style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                    {[...Array(rows)].map((_, row) => {
                        return (
                            <tr style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                {
                                    [...Array(columns)].map((x, col) => {
                                        const option = puzzle.grid?.find(
                                            (i) => i.column === col && i.row === row
                                        )?.option
                                        const answerIndex = answers.indexOf(option || '')
                                        let butt = '#E4441A'
                                        if (answerIndex >= 0 && answerStatuses[answerIndex] === true) {
                                            butt = 'green'
                                        } else if (answerIndex >= 0 && answerStatuses[answerIndex] === false) {
                                            butt = '#FFA500'
                                        } else if (answerIndex >= 0) {
                                            butt = 'gray'
                                        }

                                        return (
                                            <td>
                                                {option
                                                    && (
                                                        <Button
                                                            style={{
                                                                minWidth: 220,
                                                                backgroundColor: butt,
                                                                color: 'white',
                                                                marginBottom: '15px'
                                                            }}
                                                            disabled={allFinished || answerIndex >= 0}
                                                            type="button"
                                                            onClick={() => setAnswer(option)}>
                                                            {option}
                                                        </Button>
                                                    )}
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </GamePuzzleTemplate>
    )
}
